/**
 * Internal Invozio account used to send collection/invoice-fee invoices to freelancers.
 * This account is exempt from the standard minimum invoice amount limit.
 */
export const INTERNAL_COLLECTION_FEE_ACCOUNT_USER_ID = 10972;

export const isInternalCollectionFeeAccount = (userId: unknown): boolean => {
  return Number(userId) === INTERNAL_COLLECTION_FEE_ACCOUNT_USER_ID;
};
